export function getTranslation(lang: string): {
    search: string;
    noResults: string;
} {
    const translationStrings = {
        en: {
            search: 'Search',
            noResults: 'No results found',
        },
        es: {
            search: 'Buscar',
            noResults: 'No se han encontrado resultados',
        }
    }
    return translationStrings[lang];
}
